import { Link } from "react-router-dom";
import { BRAND } from "@/config/links";
import { useLang } from "@/i18n";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

/**
 * Minimal header for the /book* booking flow — logo + language selector
 * only. No mega-menu, no "Book a Free Consultation" CTA (the visitor is
 * already inside the booking flow) — per the booking-journey spec.
 */
export const CompactHeader = () => {
  const { t, l } = useLang();
  return (
    <header className="relative z-20 border-b border-ink/10 bg-paper" data-testid="book-compact-header">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to={l("/")} data-testid="book-compact-logo" className="flex flex-col leading-none">
          <span className="font-serif text-xl md:text-2xl tracking-tight text-ink">{BRAND.company}</span>
          <span className="font-hand text-terracotta text-base md:text-lg -mt-1">{t("brand.tagline_hand")}</span>
        </Link>
        <LanguageSwitcher variant="desktop" />
        <div className="lg:hidden">
          <LanguageSwitcher variant="mobile" />
        </div>
      </div>
    </header>
  );
};

export default CompactHeader;
